import { FARM_LIST_SORT_OPTIONS } from 'Config/constans';

export default {
  list: [],
  listCount: 0,
  listLoading: false,
  listLoaded: false,
  farmData: {},
  farmDataLoading: false,
  farmDataLoaded: false,
  farmUnfinishedInvestment: {},
  farmUnfinishedInvestmentLoading: false,
  isUserWatch: false,
  isUserWatchLoading: false,
  farmSortValue: FARM_LIST_SORT_OPTIONS[0].value,
  closedSuccessfullyList: [],
  closedSuccessfullyListCount: 0,
  closedSuccessfullyListLoading: false,
};
